<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="2" class="pt-2">
        <div class="text-left">{{ sample.identifier }}</div>
      </b-col>
      <b-col>
        <b-form-group label="Type" :label-cols="1" :horizontal="true">
          <b-form-input
            type="text"
            v-model="type"
            disabled
            placeholder="Sample Type"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="currentSubmission.samples.length > 1" cols="1" class="pl-0">
        <b-button variant="danger" block @click="removeSample"
          ><i class="fal fa-trash" />
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProjectFeedMixerSample",
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    sampleId: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    sample() {
      return this.currentSubmission.samples.find(
        (sample) => sample.test_package_sample_id === this.sampleId
      );
    },
    type() {
      return this.sample.sample_feed_mixer_efficiency.type;
    },
  },
  methods: {
    removeSample() {
      this.$emit("updateSampleList", { action: "remove", id: this.sampleId });
    },
  },
};
</script>
